import { render, staticRenderFns } from "./notificationGroupsEdit.vue?vue&type=template&id=3917465b&"
import script from "./notificationGroupsEdit.vue?vue&type=script&lang=js&"
export * from "./notificationGroupsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports